
    <div class="client-details-container mx-3 mt-3" *ngIf="clientDetails">
        <div class="row">
                <!-- Identification -->
          <div class="col-md-4 col-lg-3 mb-4">
            <span class="label">Identification :</span>
            <p>{{ clientDetails.identification }}</p>
          </div>

          <!-- Raison sociale -->
          <div class="col-md-4 col-lg-3 mb-4">
            <span class="label">Raison sociale :</span>
            <p>{{ clientDetails.socialReason }}</p>
          </div>

          <!-- Siège social -->
          <div class="col-md-4 col-lg-3 mb-4">
            <span class="label">Siège social :</span>
            <p>{{ clientDetails.headQuarter }}</p>
          </div>

          <!-- Secteur d’activité -->
          <div class="col-md-4 col-lg-3 mb-4">
            <span class="label">Secteur d’activité :</span>
            <p>{{ clientDetails.activityField }}</p>
          </div>

          <!-- ICE -->
          <div class="col-md-4 col-lg-3 mb-4">
            <span class="label">ICE :</span>
            <p>{{ clientDetails.ice }}</p>  <!-- Assure-toi que clientDetails.ice existe -->
          </div>

          <!-- Adresse -->
          <div class="col-md-4 col-lg-3 mb-4">
            <span class="label">Adresse :</span>
            <p>{{ clientDetails.address }}</p>
          </div>

          <!-- Adresse de facturation -->
          <div class="col-md-4 col-lg-3 mb-4">
            <span class="label">Adresse de facturation :</span>
            <p>{{ clientDetails.billingAddress == null ? clientDetails.address : clientDetails.billingAddress }}</p>
          </div>

          <!-- Statut -->
          <div class="col-md-4 col-lg-3 mb-4">
            <span class="label">Statut :</span>
            <p>{{ clientDetails.flag ? "Actif" : "Inactif" }}</p>
          </div>


            <div class="col-md-4 col-lg-3 mb-4">
                <span class="label">Téléphone :</span>
                <p>{{ clientDetails.phone }}</p>
            </div>


            <div class="col-md-4 col-lg-3 mb-4">
                <span class="label">Fax :</span>
                <p>{{ clientDetails.fax }}</p>
            </div>

   

            <div class="col-md-4 col-lg-3 mb-4">
                <span class="label">E-mail :</span>
                <p>{{ clientDetails.mail }}</p>
            </div>

            <div class="col-md-8 col-lg-9 mb-4">
                <span class="label">Notes :</span>
                <p>{{ clientDetails.note }}</p>
            </div>
        </div>

    </div>

    <div *ngIf="!clientDetails" class="no-client-details">
        <p>Aucun détail de client disponible.</p>
    </div>
